import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { useState } from 'react';
import { setCartData } from '@beef/layout-kit/actions';
import { CART_URL, handleSuccessRequest } from '@beef/layout-kit/utils';
import { getLegacyStore } from '@beef/legacy-beeline-store';
import { formatCountrySeasonOrderData } from "./utils";
// todo: так делать не стоит, в данном случае исключение
var globalStore = getLegacyStore();

/** Хук события перехода в корзину
 * Копипаст существующего useConnectBasket с кастомным formatCountrySeasonOrderData
 * для добавления продуктов (роутера и роутера+антенны) с согласованным хардкодом параметров */
export var useConnectBasket = function useConnectBasket(_ref) {
  var basketPayload = _ref.basketPayload;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var onConnect = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var requestData, cartApi, _yield$cartApi$post, data;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            requestData = formatCountrySeasonOrderData(basketPayload);
            _context.prev = 2;
            cartApi = globalStore.getState().external.cartData.cartApi;
            _context.next = 6;
            return cartApi.post(requestData.apiEndpoint, requestData.body);
          case 6:
            _yield$cartApi$post = _context.sent;
            data = _yield$cartApi$post.data;
            if (data.id) {
              handleSuccessRequest({
                cartId: data.id,
                items: data.items
              });
              globalStore.dispatch(setCartData(data));
              if (typeof window !== 'undefined') {
                window.location.href = CART_URL;
              }
            }
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](2);
            console.error(_context.t0);
          case 14:
            _context.prev = 14;
            setIsLoading(false);
            return _context.finish(14);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 11, 14, 17]]);
    }));
    return function onConnect() {
      return _ref2.apply(this, arguments);
    };
  }();
  return {
    isLoading: isLoading,
    onConnect: onConnect
  };
};